import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCourt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCourt"><Path d="M3.5 20.5H20.75M3.5 9.5H20.5V5.25L12 2.5L3.5 5.25V9.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6 18.5L6 9.5M10 18.5L10 9.5M14 18.5L14 9.5M18 18.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCourt;
